import React, { useEffect } from 'react'
import UserPage from '../../common/UserPage/UserPage';
import Footer from '../../common/Footer/Footer';
import TherapistPaymentPage from '../../components/TherapistPayment/TherapistPaymentPage';
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentTherapist } from '../../redux/therapistSlice'

function TherapistPayment() {
        const dispatch = useDispatch();

  const therapistState = useSelector((state) => state.therapist) || {};
  const { therapist} = therapistState;

  useEffect(() => {
    dispatch(getCurrentTherapist());
  }, [dispatch]);
  return (
    <div>
    <UserPage customImage={therapist?.picture} />
    <TherapistPaymentPage />
    <Footer />
    </div>
  )
}

export default TherapistPayment